import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRightS = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.5 5L9 8L6.5 11",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgChevronRightS;
